module.exports = __webpack_public_path__ + "img/alur-pendaftaran-desain-industri.a219f50a.png";